<template>
    <m-share>
        
            <div class="table-cell h-screen align-middle relative" >

                <div class="absolute h-screen bg-white border-r-2 border-primary-600" style="width: 150%; transform: skewX(-8deg); top: 0; left: -25%; z-index: -1"></div>
                
                <form @submit.prevent="login">
                    <div class="pl-12">
                        <div class="p-4 sprite-login-marisit" id="login-logo"></div>
                        <div class="mt-6 text-xs" :class="errorClass($v.user.$error)">Username</div>
                        <m-text class="w-full" format-style="w-full" v-model="user" :error="$v.user.$error" name="username" :bottom="true"
                                :autocomplete="true"></m-text>
                        <div class="mt-6 text-xs" :class="errorClass($v.pass.$error)">Password</div>
                        <m-password class="w-full" v-model="pass" :required="true" :error="$v.pass.$error"
                                    :bottom="true"></m-password>
                        <div class="p-4 text-error-500">{{ error }}</div>
                        <div class="text-sm">
                            <m-checkbox class="align-middle" v-model="agree" :error="$v.agree.$error"></m-checkbox>
                            <div class="align-middle inline-flex items-center">
                                <div class="flex-inline align-middle select-none cursor-pointer pl-2" @click="agree = !agree">I agree
                                    to the Terms of use 
                                </div>
                                <div class="flex-inline align-middle text-gray-700 select-none cursor-pointer hover_primary-200 px-1"
                                     @click.prevent="showTerms = true">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z" />
                                    </svg>
                                </div>
                            </div>
                            <div class="float-right text-center">
                                <input class="btn btn-primary" type="submit" value="Login"/>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                        <div class="p-1 text-error-500 text-sm" v-show="$v.agree.$error">*Please accept the terms of use
                        </div>
    
                      <m-dialog :show.sync="otp.show" heading="Enter OTP">
                        
                        <div class="text-sm m-1">OTP sent. Check your email.</div>
                        
                        <div class="text-center">
                            <input
                                v-for="(input, index) in otp.inputs"
                                :key="index"
                                ref="otpInputs"
                                type="text"
                                v-focus="index === 0"
                                class="inline-block m-2 p-2 border w-8"
                                :value="input"
                                @input="handleInput(index, $event.target.value)"
                            >
                        </div>
    
                        <div class="p-1 text-error-500 text-sm" v-show="otp.error">OTP not valid<br/> 
                            Your account will be locked after 3 wrong attempts.
                        </div>
                          
                        <template slot="footer">
                          <div class="btn btn-error mr-2" @click="otp.show = false">Cancel</div>
                          <div class="btn btn-success" @click="submitOtp">Submit</div>
                        </template>
                      </m-dialog>
                      
                        <m-dialog :show.sync="showTerms" heading="Terms of use" width="600px">
                            <m-serverdom id="terms-server"></m-serverdom>
                            <template slot="footer">
                                <div class="btn btn-error mr-2" @click="termsClicked(false)">Disagree</div>
                                <div class="btn btn-success" @click="termsClicked(true)">Agree</div>
                            </template>
                        </m-dialog>
    
                        <m-dialog :show.sync="showPrivacy" heading="Reseller Privacy Notice" width="600px">
    
                            <privacy-content v-if="showPrivacy"/>
    
                            <template slot="footer">
                                <div class="btn btn-success" @click="showPrivacy = false">Ok</div>
                            </template>
                        </m-dialog>
                        
                        
                        <div class="mt-8">
                            <div class="float-left"><a class="text-primary text-sm cursor-pointer py-1 px-3 shadow-md border border-primary rounded-full inline-flex items-center"
                                                       href="http://www.marisit.co.za/web-services/#subscribe"
                                                       target="_blank">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.042 21.672 13.684 16.6m0 0-2.51 2.225.569-9.47 5.227 7.917-3.286-.672ZM12 2.25V4.5m5.834.166-1.591 1.591M20.25 10.5H18M7.757 14.743l-1.59 1.59M6 10.5H3.75m4.007-4.243-1.59-1.59" />
                                </svg>
                                Register for this service!</a></div>
                            <div class="float-right"><a class="cursor-pointer text-orange-500 text-sm py-1 px-2 shadow-md border border-orange-500 rounded-full inline-flex items-center"
                                                        @click="showforgot = true">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M7.864 4.243A7.5 7.5 0 0 1 19.5 10.5c0 2.92-.556 5.709-1.568 8.268M5.742 6.364A7.465 7.465 0 0 0 4.5 10.5a7.464 7.464 0 0 1-1.15 3.993m1.989 3.559A11.209 11.209 0 0 0 8.25 10.5a3.75 3.75 0 1 1 7.5 0c0 .527-.021 1.049-.064 1.565M12 10.5a14.94 14.94 0 0 1-3.6 9.75m6.633-4.596a18.666 18.666 0 0 1-2.485 5.33" />
                                </svg>
                                Forgot Password?</a></div>
                            <div class="clearfix"></div>
                            
                        </div>

                        <div class="mt-16 flex justify-center" >
                            <img src="/images/iso-certification.png" alt="ISO 27001:2022 Certified" class="object-contain" />
                        </div>

                    </div>
                </form>
                
                
                <m-forgot v-if="showforgot" :show.sync="showforgot"></m-forgot>
                <m-reset v-if="showReset" :show.sync="showReset" :token="token"></m-reset>
            </div>
            
    </m-share>
</template>
<script>
import Ajax from '../js/ajax.js'
import Axios from 'axios'
import {required} from 'vuelidate/lib/validators'
import Share from './share.vue'
import Forgot from './forgot.vue'
import Reset from './reset.vue'
import share from '../share.js'

function extractQueryParams() {
    var match
    var pl = /\+/g  // Regex for replacing addition symbol with a space
    var search = /([^&=]+)=?([^&]*)/g
    var decode = function (s) {
        return decodeURIComponent(s.replace(pl, " "));
    }
    var query = window.location.search.substring(1);

    var urlParams = {};
    while (match = search.exec(query))
        urlParams[decode(match[1])] = decode(match[2]);

    return urlParams
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

var queryParams = extractQueryParams()

const loginStatus = {
  Success: 0,
  WrongUserNameOrPassword: 1,
  ExceededLoginAttempts: 2,
  Inactive: 3,
  OtpRequired: 4
};

const loginStatusString = {
  0: "",
  1: "Wrong username or password.",
  2: "You have exceeded the maximum amount of failed login attempts. Please contact MarisIT to unlock your account.",
  3: "Your account has been deactivated. Please contact MarisIT on (012) 542 7614 to activate your account.",
  4: ""
}

export default {
    components: {
        'm-share': Share,
        'm-forgot': Forgot,
        'm-reset': Reset,
        
        'privacy-content': function (resolve, reject) {
            import(/* webpackChunkName: "privacy" */ './privacy.vue').then(module => {
                resolve(module.default);
            });
        }
    },
    data() {
        return {
            token: '',
            error: '',
            valid: false,
            user: "",
            pass: "",
            agree: false,
            showTerms: false,
            show: false,
            showforgot: false,
            otp: {
              show: false,
              // array to store the individual input values
              inputs: ['', '', '', ''],
              error: false  
            },
            showReset: false,
            showPrivacy: false,
            privacyContent: null
        };
    },
    mounted() {
        this.user = getCookie('username')

        var token = queryParams.token
        if (token && token.length > 0) {
            this.showReset = true
            this.token = token
        }
    },
    created() {
        document.getElementById('privacy').addEventListener('click', this.privacyClicked);
    },
    destroyed() {
        document.getElementById('privacy').removeEventListener('click', this.privacyClicked);
    },
    validations: {
        user: {required},
        pass: {required},
        agree: {checked: val => val === true}
    },
    computed: {
        isError() {
            return this.error.length > 0
        }
    },
    methods: {
        handleInput(index, value) {
            if (value.length > 1) {
                // If more than one character is entered, trim to just the last character
                value = value[value.length - 1]
            }
            // Update the input value in the array
            this.$set(this.otp.inputs, index, value)

            if (index < this.otp.inputs.length - 1) {
                // Move focus to the next input if a character is entered
                this.$refs.otpInputs[index + 1].focus();
            }
            if (index == this.otp.inputs.length - 1) {
                // If the last input is filled, submit the OTP
                this.submitOtp()
            }
        },
        submitOtp() {
            this.otp.show = false;
            const code = this.otp.inputs.join('')
            share.showLoader()
            Axios.post("/auth/otp", {code: code, user: this.user })
            .then(resp => {
                if (resp.data === true) {
                    this.loggedIn();
                    return;
                }

                share.hideLoader()
                this.otp.show = true;
                this.otp.error = true;
                this.otp.inputs = this.otp.inputs.map(() => '');
            }).catch(() => {
                share.hideLoader()
            })
        },
        privacyClicked() {
            this.showPrivacy = true;
        },
        errorClass(state) {
            return state ? 'text-error-500' : 'text-gray-600'
        },
        termsClicked(state) {
            this.agree = state
            this.showTerms = false
        },
        loggedIn() {
            // Not just a Vue router change, but whole new home page,
            // !! Set username in cookie to autofill on landing. 50days expiry
            setCookie('username', this.user, 50)
            window.location = "/";
        },
        login(e) {
            this.$v.$touch()
            if (this.$v.$invalid) {
                return
            }
            share.showLoader()
            Axios.post("/auth/login", {
                user: this.user,
                pass: this.pass
            }).then(resp => {
                var status = resp.data
                if (status === loginStatus.Success) {
                    this.loggedIn();
                    return;
                }
                
                share.hideLoader()
                if (status === loginStatus.OtpRequired) {
                    this.otp.show = true
                    this.otp.error = false;
                    this.otp.inputs = this.otp.inputs.map(_ => '') 
                    return
                }
                this.error = loginStatusString[status]
            }).catch(err => {
                share.showSnack('Whoops! An unexpected error has occurred. Our team has been notified. Please try again later.', 'error')
                share.hideLoader()
            })
            e.preventDefault();
        }
    }
};
</script>
